module.exports = __webpack_public_path__ + "media/images/help/about/heading-reason-4-ae4e8377c222a1ce04b7bfab507938f1.svg";